//Using the react library
import React from "react";
//Using the react library:
import { useEffect, useState } from "react";
//API Middle man
import useApi from "../utils/UseAPI";
// React loading spinner
import Spinner from "react-bootstrap/Spinner";
import SanitizeHref from "../utils/SanitizeHref";

function DPRFormsLibrary() {
  const { error, processing, getRequest } = useApi();
  const [allForms, setAllForms] = useState([]);

  useEffect(() => {
    const fetchLinks = async () => {
      const [data, status] = await getRequest(null, "form/dpr-pb/dpr?sfy=2026");
      if (status == 200) {
        setAllForms(data.data.dpr);
      } else {
        console.log(error);
      }
    };
    fetchLinks();
  }, []);

  return (
    <div className="container py-4">
      <h2 id="all-forms-by-number" className="mb-4 border-bottom pb-2">
        All Forms By Number
      </h2>
      {processing ? (
        <div className="text-center p-5" aria-live="polite">
          <Spinner animation="border" variant="success" />
          <p className="mt-2 text-muted">Loading forms...</p>
        </div>
      ) : (
        <div className="row g-3">
          {allForms.map((data, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4">
              <div className="quick-links-body h-100">
                <a
                  href={SanitizeHref(
                    `documents/cmhc/pb/${data.formName}${data.formExtention}`,
                  )}
                  className="d-flex align-items-center p-3 text-decoration-none border rounded h-100 hover-shadow bg-light"
                  title={`Download ${data.formName}`}
                >
                  {/* document icon */}
                  <span className="me-3 fs-4" aria-hidden="true">
                    📄
                  </span>

                  <div className="d-flex flex-column">
                    <span className="fw-bold text-primary">
                      {data.formName}
                    </span>

                    <span className="small text-muted">Download Document</span>
                  </div>
                </a>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default DPRFormsLibrary;
